import templateStr from 'text!./edit-account-psa.html';
import 'gw-portals-featuredetection-js/ApplicationFeatures';
//Account Lib
import {PhoneNumberUtil} from 'libphonenumber';
//import ApplicationFeatures from 'gw-portals-featuredetection-js/ApplicationFeatures';
import nameUtil from 'edge/gateway/util/NameUtil';
export default () => {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            submissionVm :'=',
            isGatewayportalnewsubmission: '=',
            updateEditOption :'='
        },controller: ['$scope', '$translate','$state', '$q', '$filter', 'AccountService', 'UserService', 'ModalService', 'ViewModelService', 'CountrySpecificPSA', 'InsuranceSuiteMetadata',  'defaultLocaleDetails',
                 ($scope,$translate, $state, $q, $filter, AccountService, UserService, ModalService, ViewModelService, CountrySpecificPSA, InsuranceSuiteMetadata,  defaultLocaleDetails) => {
            init();
            let countryWatchPSA ;
            function init() {
                 //Edit Account Screen: 
                //shouldShowEditContactButton();
                $scope.EmailAttempt = 0;
                if($scope.isGatewayportalnewsubmission){
                    $scope.accountInfo = {
                        loaded: false
                    };
                    $scope.accountNumber =  $scope.submissionVm.baseData.accountNumber.value;
                    $scope.lists = [
                        { 'vl': "mail", checked: false },
                        { 'vl': "phone", checked: false },
                        { 'vl': "sms", checked: false },
                        { 'vl': "bypost", checked: false },
                    ];
                    $scope.accountDetail = {
                        accountHolder: {},
                    };
                    const TRANSLATION_KEYS = {
                        mail: 'psa.gateway.puw.views.new-quote-account-contact.Email',
                        phone: 'psa.gateway.puw.views.new-quote-account-contact.Phone',
                        sms: 'psa.gateway.puw.views.new-quote-account-contact.sms',
                        bypost: 'psa.gateway.puw.views.new-quote-account-contact.post'
                    };
            
                    /**
                         * Get the translation for the contactInfo(added as part of client consent)
                         * @param {String} contactKey
                         * @returns {String}
                         */
                    $scope.getContactInfoTranslation = (contactKey) => {
                        const translationKey = TRANSLATION_KEYS[contactKey];
                        let returnString = '';
                        if (translationKey) {
                            returnString = $translate.instant(translationKey);
                        }
                        return returnString;
                    };
                    initialiseScopeVariables();
                    getAccountDetails();
                }
            
                //Edit Account INIT ENDS
            }
             //Edit Account Functionality Starts
            /* Private Functions*/
            function initialiseScopeVariables() {
                $scope.isEditingContactDetails = false;
                $scope.hideFields = ['AddressLine2', 'AddressLine3']; // PSA
                $scope.CountrySpecificPSA = CountrySpecificPSA;
            }

            function findAccount (accountNumber)  {
                if (angular.isDefined(accountNumber) && accountNumber.length > 0) {
                    const findAccountPromise = AccountService.getAccountDetails(accountNumber);
                    $scope.findAccountPromise = findAccountPromise;

                    $q.when(findAccountPromise, (account) => {
                        if (account.accountHolder) {
                            $scope.lists.forEach(function (list) {
                                account.accountHolder.contactsInfoData.forEach(function (i) {
                                    if (list.vl === i) {
                                        list.checked = true;
                                    }
                                });
                                //Link 1
                                $scope.accountInfoCopyView.contactsInfoData.value =  account.accountHolder.contactsInfoData;
                                refreshOrganizationTypes_PSA();
                            })
                        } else {
                            ModalService.showError('gateway.views.modal.Error', 'gateway.views.new-quote.error.findAccount.account.type');
                            window.history.back();
                        }
                    }, (e) => {
                        const msg = $translate('gateway.views.new-quote.error.findAccount.noaccount', {
                            accountNumber
                        });
                        ModalService.showError('gateway.views.modal.Error', msg);
                        //$state.go('newQuoteSearch');
                    });
                }
            };
            function getUpdatedAccountContactDetails() {
                const updatedAccount = {};
                const accountHolder = {};
                updatedAccount.accountNumber = $scope.accountInfoCopy.accountNumber;

                if ($scope.accountInfoCopy.subtype === 'Person') {
                    accountHolder.contactName = $scope.accountInfoCopy.contactName;
                    accountHolder.subtype = 'Person';
                    accountHolder.prefix = $scope.accountInfoCopy.prefix;
                    accountHolder.firstName = $scope.accountInfoCopy.firstName;
                    accountHolder.lastName = $scope.accountInfoCopy.lastName;
                    accountHolder.primaryAddress = $scope.accountInfoCopy.primaryAddress;
                    accountHolder.contactsInfoData = $scope.accountInfoCopy.contactsInfoData;
                    // Link-1
                    $scope.accountInfoCopy.contactsInfoData = [];
                    $scope.lists.forEach(function (list) {
                        if(list.checked == true ) {
                            $scope.accountInfoCopy.contactsInfoData.push(list.vl)
                        }
                    });
                    //UCWPRODENG-834
                    accountHolder.contactsInfoData = $scope.accountInfoCopy.contactsInfoData;
                    if ($scope.accountInfoCopy.primaryPhoneType) {
                        accountHolder.primaryPhoneType = $scope.accountInfoCopy.primaryPhoneType;
                    } else if ($scope.accountInfoCopy.homeNumber) {
                        accountHolder.primaryPhoneType = 'home';
                    }

                    accountHolder.workNumber = ($scope.accountInfoCopy.workNumber) ? $scope.accountInfoCopy.workNumber : null;
                    accountHolder.homeNumber = ($scope.accountInfoCopy.homeNumber) ? $scope.accountInfoCopy.homeNumber : null;
                    accountHolder.cellNumber = ($scope.accountInfoCopy.cellNumber) ? $scope.accountInfoCopy.cellNumber : null;
                    accountHolder.emailAddress1 = ($scope.accountInfoCopy.emailAddress1) ? $scope.accountInfoCopy.emailAddress1 : null;
                    accountHolder.faxNumber = ($scope.accountInfoCopy.faxNumber) ? $scope.accountInfoCopy.faxNumber : null;
                    accountHolder.url = $scope.accountInfoCopy.url;

                    updatedAccount.accountHolder = accountHolder;
                } else if ($scope.accountInfoCopy.subtype === 'Company') {
                    accountHolder.contactName = $scope.accountInfoCopy.contactName;
                    accountHolder.subtype = 'Company';
                    accountHolder.primaryAddress = $scope.accountInfoCopy.primaryAddress;
                    accountHolder.contactsInfoData = $scope.accountInfoCopy.contactsInfoData;
                    accountHolder.primaryPhoneType = $scope.accountInfoCopy.primaryPhoneType ? $scope.accountInfoCopy.primaryPhoneType : 'work';
                    accountHolder.workNumber = ($scope.accountInfoCopy.workNumber) ? $scope.accountInfoCopy.workNumber : null;
                    accountHolder.homeNumber = ($scope.accountInfoCopy.homeNumber) ? $scope.accountInfoCopy.homeNumber : null;
                    accountHolder.cellNumber = ($scope.accountInfoCopy.cellNumber) ? $scope.accountInfoCopy.cellNumber : null;
                    accountHolder.emailAddress1 = ($scope.accountInfoCopy.emailAddress1) ? $scope.accountInfoCopy.emailAddress1 : null;
                    accountHolder.fiscalCode_PSA = $scope.accountInfoCopy.fiscalCode_PSA; //PSA
                    accountHolder.companyRegNum_PSA = $scope.accountInfoCopy.companyRegNum_PSA; // PSA
                    accountHolder.organizationType_PSA = $scope.accountInfoCopy.organizationType_PSA; // PSA
                    accountHolder.prefix = $scope.accountInfoCopy.prefix;
                    accountHolder.firstName = $scope.accountInfoCopy.firstName; // PSA
                    accountHolder.lastName = $scope.accountInfoCopy.lastNgame; // PSA
                    accountHolder.email = $scope.accountInfoCopy.email;
                    accountHolder.mobilePhone = $scope.accountInfoCopy.mobilePhone;
                    accountHolder.sms = $scope.accountInfoCopy.sms;
                    accountHolder.byPost = $scope.accountInfoCopy.byPost;
                    // PSA accountHolder.ProducerCode = '';
                    accountHolder.prefix = $scope.accountInfoCopy.prefix;
                    accountHolder.faxNumber = ($scope.accountInfoCopy.faxNumber) ? $scope.accountInfoCopy.faxNumber : null;
                    // Link-1
                    $scope.accountInfoCopy.contactsInfoData = [];
                    $scope.lists.forEach(function (list) {
                        if (list.checked == true) {
                            $scope.accountInfoCopy.contactsInfoData.push(list.vl)
                        }
                    });
                    //UCWPRODENG-834
                    accountHolder.contactsInfoData = $scope.accountInfoCopy.contactsInfoData;
                    updatedAccount.accountHolder = accountHolder;
                }

                return updatedAccount;
            }

            /* Scope Functions*/
            function beginEditAccountContactDetails () {
                $scope.accountInfoCopy = angular.copy($scope.accountInfo);
                
                $scope.isEditingContactDetails = true;
                $scope.accountInfoCopyView = ViewModelService.create($scope.accountInfoCopy, 'pc', 'edge.capabilities.policycommon.accountcontact.dto.AccountContactDTO');
                
                findAccount($scope.accountNumber);
                

                countryWatchPSA = $scope.$watch('accountInfoCopy.primaryAddress.country', () => {
                    refreshOrganizationTypes_PSA();
                });

            };

            function refreshOrganizationTypes_PSA ()  {
                $scope.organizationTypes_PSA = $scope.CountrySpecificPSA.orgTypesFor($scope.accountInfoCopy.primaryAddress.country);
            };

            $scope.cancelEditAccountContactDetails = function ()  {
                $scope.isEditingContactDetails = false;
                $scope.isGatewayportalnewsubmission = false;
                $scope.updateEditOption(false);
                $scope.$parent.effectiveStateFlowModel.cancel($scope.submissionVm, {withdraw: false});
            };

           function replaceNullValues ()  {
                $scope.accountInfoCopy.homeNumber = $scope.accountInfoCopy.homeNumber || null;
                $scope.accountInfoCopy.workNumber = $scope.accountInfoCopy.workNumber || null;
                $scope.accountInfoCopy.cellNumber = $scope.accountInfoCopy.cellNumber || null;
                $scope.accountInfoCopy.emailAddress1 = $scope.accountInfoCopy.emailAddress1 || '';
                $scope.accountInfoCopy.primaryPhoneType = $scope.accountInfoCopy.primaryPhoneType || '';
                $scope.accountInfoCopy.primaryAddress.addressLine1 = $scope.accountInfoCopy.primaryAddress.addressLine1 || '';
                $scope.accountInfoCopy.primaryAddress.addressLine2 = $scope.accountInfoCopy.primaryAddress.addressLine2 || '';
                $scope.accountInfoCopy.primaryAddress.city = $scope.accountInfoCopy.primaryAddress.city || '';
                $scope.accountInfoCopy.primaryAddress.country = $scope.accountInfoCopy.primaryAddress.country || '';
                $scope.accountInfoCopy.primaryAddress.postalCode = $scope.accountInfoCopy.primaryAddress.postalCode || '';
                $scope.accountInfoCopy.primaryAddress.state = $scope.accountInfoCopy.primaryAddress.state || '';
            };

            $scope.updateContactDetails = (contactDetailsForm) => {
                contactDetailsForm.submitted = true;

                if (contactDetailsForm.invalid) {
                    return;
                }
                
                const updatedAccount = getUpdatedAccountContactDetails();
                if((updatedAccount.accountHolder.emailAddress1 == null && $scope.EmailAttempt == 0) ){
                    $scope.emailValidation = $translate.instant('gateway.views.new-quote-account-search.ContactType.EmailValidation');
                    $scope.EmailAttempt = 1;
                    return ;
                }
                const updateContactDetailsPromise = AccountService.updateAccountDetails(updatedAccount);
                $scope.updateContactDetailsPromise = updateContactDetailsPromise;

                $q.when(updateContactDetailsPromise)
                    .then(mapAccountDetails)
                    .then(() => {
                        $scope.isEditingContactDetails = false;
                    })
                    .then(() => {
                        ModalService.showInfo('gateway.views.account-detail.Saved Title', 'gateway.views.account-detail.Saved Message');
                        $scope.isGatewayportalnewsubmission = false;
                        $scope.updateEditOption(false);
                        //UCWAR-1418 - update data for next screens to quote successfully
                        updateAccountHolder(updatedAccount);
                    })
                    .then(() => {
                        // refresh new organization type
                        $scope.accountInfo.organizationTypeName_PSA = $scope.accountInfoCopy.organizationType_PSA ? $scope.accountInfoCopyView.organizationType_PSA.value.name : null; // PSA
                        countryWatchPSA();
                    })
                    .catch((e) => {
                        ModalService.showError('gateway.views.account-detail.Save Failed Title', 'gateway.views.account-detail.Save Failed Message', '');
                        $scope.isGatewayportalnewsubmission = false;
                        $scope.updateEditOption(false);
                    });
            };

            function shouldShowContactPerson_PSA ()  {
                return $scope.accountInfo.prefix || $scope.accountInfo.firstName || $scope.accountInfo.lastName || $scope.accountInfo.emailAddress1;
            };

            //UCWAR-1418 - Updating the UI objects to reflect the updated account details
            function updateAccountHolder (updatedAccount) {
                $scope.submissionVm.baseData.accountHolder.firstName = updatedAccount.accountHolder.firstName;
                $scope.submissionVm.baseData.accountHolder.lastName = updatedAccount.accountHolder.lastName;
                if (updatedAccount.accountHolder.subtype === 'Person') {
                    $scope.submissionVm.baseData.accountHolder.prefix = updatedAccount.accountHolder.prefix;
                    $scope.submissionVm.baseData.accountHolder.contactName = updatedAccount.accountHolder.firstName + ' ' + updatedAccount.accountHolder.lastName;
                    $scope.submissionVm.baseData.accountHolder.displayName = updatedAccount.accountHolder.prefix + '. ' + updatedAccount.accountHolder.firstName + ' ' + updatedAccount.accountHolder.lastName;
                } else {
                    $scope.submissionVm.baseData.accountHolder.displayName = updatedAccount.accountHolder.contactName;
                    $scope.submissionVm.baseData.accountHolder.contactName = updatedAccount.accountHolder.contactName;
                    $scope.submissionVm.baseData.accountHolder.fiscalCode_PSA = updatedAccount.accountHolder.fiscalCode_PSA; //PSA
                    $scope.submissionVm.baseData.accountHolder.companyRegNum_PSA = updatedAccount.accountHolder.companyRegNum_PSA; // PSA
                    $scope.submissionVm.baseData.accountHolder.organizationType_PSA = updatedAccount.accountHolder.organizationType_PSA; // PSA
                }
                $scope.submissionVm.baseData.accountHolder.url = updatedAccount.accountHolder.url;
                $scope.submissionVm.baseData.accountHolder.homeNumber = updatedAccount.accountHolder.homeNumber;
                $scope.submissionVm.baseData.accountHolder.workNumber = updatedAccount.accountHolder.workNumber;
                $scope.submissionVm.baseData.accountHolder.cellNumber = updatedAccount.accountHolder.cellNumber;
                $scope.submissionVm.baseData.accountHolder.emailAddress1 = updatedAccount.accountHolder.emailAddress1;
                $scope.submissionVm.baseData.accountHolder.contactsInfoData = updatedAccount.accountHolder.contactsInfoData
                $scope.submissionVm.baseData.accountHolder.primaryAddress = updatedAccount.accountHolder.primaryAddress;
                $scope.submissionVm.baseData.policyAddress = updatedAccount.accountHolder.primaryAddress;
            }
            
            function getAccountDetails () {
                const accountDetailsPromise = AccountService.getAccountDetails($scope.accountNumber);
                $scope.accountDetailsPromise = accountDetailsPromise;

                return $q.when(accountDetailsPromise)
                    .then(mapAccountDetails)
                    .then(() => {
                        $scope.accountInfo.loaded = true;
                        beginEditAccountContactDetails()
                    })
                    .catch((e) => {
                        const msg = $translate('gateway.views.account-detail.findAccount.noaccount', {
                            accountNumber: $scope.accountNumber
                        });
                        ModalService.showError('gateway.views.modal.Error', msg);
                        $scope.isGatewayportalnewsubmission = false;
                        $scope.updateEditOption(false);
                        //$state.go('accounts.index');
                    });
            };
            function mapAccountDetails   (accountDetails) {
                if (!accountDetails) {
                    return;
                }

                $scope.accountInfo.publicID = accountDetails.publicID;
                // $scope.accountInfo.policySummaries = _.filter(accountDetails.policySummaries, {
                //     isIssued: true
                // });
                $scope.accountInfo.accountNumber = accountDetails.accountNumber;
                $scope.accountInfo.canCreateSub = accountDetails.canUserCreateSubmission;
                $scope.accountInfo.accountBillingSummary = accountDetails.accountBillingSummary;
                $scope.accountInfo.accountCreatedDate = accountDetails.accountCreatedDate;
                $scope.accountInfo.statusDisplayName = accountDetails.statusDisplayName;
                $scope.accountInfo.serviceTier = accountDetails.serviceTier;
                $scope.accountInfo.accountBillingSummary = accountDetails.accountBillingSummary;
                $scope.accountInfo.producerCodes = accountDetails.producerCodes;
                $scope.accountInfo.totalPremium = accountDetails.totalPremium;

                

                setupAccountContactDetails(accountDetails.accountHolder);

                function setupAccountContactDetails(accountHolder) {
                    const phoneUtils = PhoneNumberUtil.getInstance();
                    $scope.accountInfo.subtype = accountHolder.subtype;
                    if (accountHolder.subtype === 'Person') {
                        $scope.accountInfo.prefix = accountHolder.prefix;
                        $scope.accountInfo.firstName = accountHolder.firstName;
                        $scope.accountInfo.lastName = accountHolder.lastName;
                        $scope.accountInfo.contactName = nameUtil.getDisplayName(accountHolder, ' ');
                        $scope.accountInfo.isPerson = true;
                    } else {
                        $scope.accountInfo.contactName = accountHolder.displayName;
                        $scope.accountInfo.isCommercial = true;
                        $scope.accountInfo.organizationTypeName_PSA = (accountHolder.organizationType_PSA ? InsuranceSuiteMetadata.get('pc').types.getTypelist('AccountOrgType').getCode(accountHolder.organizationType_PSA).name : null); // PSA
                        $scope.accountInfo.organizationType_PSA = accountHolder.organizationType_PSA; // PSA
                        $scope.accountInfo.fiscalCode_PSA = accountHolder.fiscalCode_PSA;
                        $scope.accountInfo.companyRegNum_PSA = accountHolder.companyRegNum_PSA;
                        $scope.accountInfo.prefix = accountHolder.prefix;
                        $scope.accountInfo.firstName = accountHolder.firstName;
                        $scope.accountInfo.lastName = accountHolder.lastName;
                    }

                    $scope.accountInfo.primaryAddress = accountHolder.primaryAddress;
                    $scope.displayAddressArray = accountHolder.primaryAddress.displayName.split(', ');
                    // PSA $scope.accountInfo.primaryAddress.stateName = InsuranceSuiteMetadata.get('pc').types.getTypelist('State').getCode(accountHolder.primaryAddress.state).name;
                    $scope.accountInfo.primaryPhoneType = accountHolder.primaryPhoneType;
                    $scope.accountInfo.homeNumber = accountHolder.homeNumber;
                    $scope.accountInfo.workNumber = accountHolder.workNumber;
                    $scope.accountInfo.cellNumber = accountHolder.cellNumber;
                    $scope.accountInfo.emailAddress1 = accountHolder.emailAddress1;
                    $scope.accountInfo.faxNumber = accountHolder.faxNumber; // PSA

                    $scope.accountInfo.primaryPhoneNumber = '';
                    if (accountHolder.primaryPhoneType === 'work' && angular.isDefined(accountHolder.workNumber) && accountHolder.workNumber.length > 0) {
                        $scope.accountInfo.primaryPhoneNumber = phoneUtils.format(phoneUtils.parse(accountHolder.workNumber, defaultLocaleDetails.countryCode));
                    } else if (accountHolder.primaryPhoneType === 'home' && angular.isDefined(accountHolder.homeNumber) && accountHolder.homeNumber.length > 0) {
                        $scope.accountInfo.primaryPhoneNumber = phoneUtils.format(phoneUtils.parse(accountHolder.homeNumber, defaultLocaleDetails.countryCode));
                    } else if (accountHolder.primaryPhoneType === 'mobile' && angular.isDefined(accountHolder.cellNumber) && accountHolder.cellNumber.length > 0) {
                        $scope.accountInfo.primaryPhoneNumber = phoneUtils.format(phoneUtils.parse(accountHolder.cellNumber, defaultLocaleDetails.countryCode));
                    }
                }
            };

    //Edit Account Functionality Ends
        }]
    };
};
